import React from 'react'

export default React.memo(props => {
    return <div></div>
})


// WEBPACK FOOTER //
// ./app/App/Module/Stock/Component/Detail/Fiche/index.js